import { catchError } from "../../utils/Helper";
import { customer } from "../axios/endpoint";
import { getRequest } from "../axios/request";

export const getCustomerDelayAnalysis = async (query, signal) => {
  try {
    const response = await getRequest(customer.delayAnalysis, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getAllCustomers = async (query, signal) => {
  try {
    const response = await getRequest(customer.all, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const customerApi = {
  getCustomerDelayAnalysis,
  getAllCustomers,
};
